export default {

	getFields() {

		return {
			loginEmail : {required: true, email: true},
			loginPassword :{required: true}
		}
	}
}export default {

	getFields() {

		return {
			loginEmail : {required: true, email: true},
			loginPassword :{required: true}
		}
	}
}